import type { AnalyticsPayload } from './analytics';

export interface RecordedAnalyticsEvent {
  name: string;
  payload?: AnalyticsPayload;
}

/** In-memory test/debug recorder. Not a vendor integration. */
export class AnalyticsDebugSink {
  readonly events: RecordedAnalyticsEvent[] = [];

  record(name: string, payload?: AnalyticsPayload): void {
    this.events.push(payload === undefined ? { name } : { name, payload });
  }

  names(): string[] {
    return this.events.map((event) => event.name);
  }

  count(name: string): number {
    return this.events.filter((event) => event.name === name).length;
  }
}
